import React from 'react';

import { EnvListContainer, HiddenEnvItem, HiddenSection } from 'features/diagnostics/components';

import { getConfigValues } from '../utils';

const ConfigSettingsContent = () => {
  return (
    <EnvListContainer>
      {Object.entries(getConfigValues()).map(([key, value]) => (
        <HiddenEnvItem key={key} envKey={key} value={JSON.stringify(value)} />
      ))}
    </EnvListContainer>
  );
};

export const ConfigSettings = () => (
  <HiddenSection title="Config Settings" content={<ConfigSettingsContent />} />
);
